export class WebhookV1SnapshotArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceProviderId",
            "baseName": "resourceProviderId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "securityScan",
            "baseName": "securityScan",
            "type": "WebhookV1SecurityScan",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1SnapshotArguments.attributeTypeMap;
    }
    constructor() {
    }
}
